/* The phone sign-in screen's own lines (phone-checkout.html frame A, .tw-*), inside the app's payment page frame. */
.lead {
  margin: 18px 0 0;
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.55;
}

.welcome {
  margin: 16px 0 0;
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.5;
}

.noTg {
  margin: 16px 0 0;
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.55;
}

.noTg b {
  color: var(--text-primary);
  font-weight: 600;
}

.noTg a {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.error {
  margin: 16px 0 0;
  color: var(--danger);
  font-size: 14px;
  line-height: 1.5;
}

.tgBtn svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.holdNote {
  margin: 10px 0 0;
  text-align: center;
  color: var(--text-tertiary);
  font-size: 12px;
}

/* Development only: the test account sign-in under the lines. */
.testAccount {
  appearance: none;
  margin: 16px 0 0;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-size: 14px;
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* The review's problem line, above the button. */
.problem {
  margin: 0 0 10px;
  text-align: center;
  color: var(--danger);
  font-size: 14px;
}
